import { useUnit } from 'effector-react';

import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { LinkButton } from 'shared/ui/Styled';
import { EmptyButton, Flex } from 'shared/ui/StyledComponents';
import { Typography } from 'shared/ui/Typography';

import { getComponentByTodoType } from '../lib/getComponentByTodoType';
import { factory } from '../model/model';

export const PrevTodoList = () => {
  const model = factory.useModel();
  const previousTodos = useUnit(model.$previousTodos);
  const isPreviousTodosVisible = useUnit(model.$isPreviousTodosVisible);

  if (!isPreviousTodosVisible) {
    return (
      <Box width='fit-content' position='relative'>
        <LinkButton onClick={() => model.checkPreviousTodos()}>посмотреть завершенные</LinkButton>
      </Box>
    );
  }

  return (
    <Box>
      {!previousTodos?.tasks?.length ? (
        <Box position='relative'>
          <Box width='100%' height={2} mb={20} background={theme.colors.gray300} />
          <Box position='absolute' right={10} top={20}>
            <EmptyButton onClick={() => model.hidePreviousTodos()}>—</EmptyButton>
          </Box>
          <Typography>Пока нет завершенных задач</Typography>
        </Box>
      ) : (
        <Box position='relative'>
          <Box position='absolute' right={10} top={20}>
            <EmptyButton onClick={() => model.hidePreviousTodos()}>—</EmptyButton>
          </Box>
          <Box width='100%' height={2} mb={20} background={theme.colors.gray300} />
          <Typography fontSize={18} marginBottom={12}>
            Последние завершенные задачи
          </Typography>
          <Flex flexDirection='column' gap={20} mb={30} width='100%'>
            {previousTodos?.tasks?.map((item, index) => (
              <Box key={index} width='100%'>
                {getComponentByTodoType({ item })}
              </Box>
            ))}
          </Flex>
        </Box>
      )}
    </Box>
  );
};
